import gql from 'graphql-tag';
import {responseField} from "../../../../base.graphql";



export const translationFields = `
  id
  en
  sw
  keyword
`;


export const CREATE_TRANSLATION = gql`
mutation SaveTranslationsMutation($input: [TranslationInput]) {
  saveTranslationsMutation(input: $input) {
    response {
      ${responseField}
    }
    data {
      ${translationFields}
    }
  }
}
`


export const GET_TRANSLATIONS = gql`
query GetAllLanguageTranslations {
  getAllLanguageTranslations {
    response {
      ${responseField}
    }
    data {
      id
      uniqueId
      transLang {
        id
        uniqueId
        langCode
        languageName
      }
      keyword
      translationText
    }
  }
}
`;
// export const GET_TRANSLATIONS = gql`
//   query GetTranslations {
//     getTranslations {
//       response {
//         ${responseField}
//       }
//       data {
//         ${translationFields}
//       }
//     }
//   }
// `;


export const REMOVE_TRANSLATIONS = gql`
mutation RemoveTranslationsMutation($keyword: String) {
  removeTranslationsMutation(keyword: $keyword) {
    response {
      ${responseField}
    }
  }
}
`;
